import { parseAmount } from "./parseAmount";

export function getItemPromotionAmount(unitPrice, quantity, promotion, isGeneralPromotion = false) {
    if (!promotion || !quantity || !unitPrice) return 0;
    const promotionType = promotion.promoDiscountType;
    const totalPromoLimit = (promotion.promoLimitPerPerson ?? 0) - (promotion.usage ?? 0);
    const productLimit = promotion.promoLimitPerPerson && !isGeneralPromotion ? Math.min(quantity, totalPromoLimit) : quantity;
   
    const maxPurchaseValue = !promotion.maxPurchaseValue ? Number.MAX_SAFE_INTEGER : promotion.maxPurchaseValue;
    if(productLimit <= 0) return 0;
    let discountAmount = 0;
    if (promotionType === "Porcentaje") {
         const limitPrice = unitPrice * productLimit;
        discountAmount = Math.min(limitPrice * (Number(promotion.discountValue) / 100), maxPurchaseValue);
    } else if (promotionType === "Monto") {
        discountAmount = Math.min(productLimit * Number(promotion.discountValue), maxPurchaseValue);
    }
    return discountAmount;
}

export function doesPromotionApply(unitPrice, quantity, promotion) {
    if (!promotion) return false;
    const totalPrice = unitPrice * quantity;
    if (promotion.minPurchaseValue && totalPrice < promotion.minPurchaseValue) {
        return false;
    }
    if (promotion.usage >= promotion.promoLimitPerPerson) {
        return false;
    }
    return true;
}

export function calculatePromotionLimits(promotion) {
    const isGeneralPromotion = !promotion.itemId;
    let maxPurchaseValue = !promotion.maxPurchaseValue ? Number.MAX_SAFE_INTEGER : promotion.maxPurchaseValue;
    if(isGeneralPromotion){
        if(promotion.promoDiscountType === "Monto"){
            maxPurchaseValue = parseAmount(promotion.discountValue);
        }
         if(promotion.promoDiscountType === "Porcentaje"){
            maxPurchaseValue = parseAmount(promotion.discountValue) * (promotion.maxPurchaseValue / 100);
        }
    }
    return promotion
        ? {
              ...promotion,
              promoLimitPerPerson: !promotion.promoLimitPerPerson ? Number.MAX_SAFE_INTEGER : promotion.promoLimitPerPerson,
              maxPurchaseValue: maxPurchaseValue,
          }
        : null;
}

export function getPromotionName(promotion) {
    if (!promotion) return "";
    const promoNames = {
        FEATURED_DATE: "Fecha Destacada",
        PRODUCT: "Por Producto",
        // Recurrent
        BIRTHDAY: "Cumpleaños",
        LOYALTY: "Lealtad",
        RECONQUEST: "Reconquista",
        FIRST_BUY: "Primera Compra",
    };
    return promoNames[promotion.promoName] || promotion.promoName;
}

export function getPromotionToApply(itemId, promotions) {
    return promotions.filter((promo) => promo.itemId === itemId).sort((a, b) => b.promoId - a.promoId)[0] ?? null;
}


export function getDecoupledItems(products){
    const decoupledItems = [];
    for(const product of products){
        if(product.promotion?.itemId){
            const promoAvailability = product.promotion.promoLimitPerPerson - product.promotion.usage;
            const applicableQuantity = Math.min(promoAvailability, product.quantity);
            if(promoAvailability < product.quantity){
            
                const cashOrCardValuePerUnit = product.cashOrCardValue / product.quantity;
                const benefitsPerUnit = product.benefits / product.quantity;
                decoupledItems.push({
                    ...product,
                    quantity: applicableQuantity,
                    cashOrCardValue: cashOrCardValuePerUnit * applicableQuantity,
                    benefits: benefitsPerUnit * applicableQuantity
                });
                const remainingQuantity = product.quantity - applicableQuantity;
                if(remainingQuantity > 0){
                    decoupledItems.push({
                        ...product,
                        quantity: remainingQuantity,
                        cashOrCardValue: cashOrCardValuePerUnit * remainingQuantity,
                        benefits: benefitsPerUnit * remainingQuantity,
                        promotion: undefined,
                        discountAmount: 0
                    });
                }
                continue;
            }
        }
        decoupledItems.push(product);
    }
    return decoupledItems;
}